import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import {action, observable} from 'mobx';
import device from 'current-device';
import * as d3 from 'd3';
import {getAngleFromD3Event, getBeatFromAngle, getInnerRadius, getOuterRadius} from './studioUtility';

@inject ('studioStore')
@observer
class StudioPlayerTrackArc extends Component {
    @observable g;
    @observable d;
    @observable startAngle;
    @observable pendingClickId = null;

    componentDidMount() {
        let svg = null;
        d3.select('#studioPlayGridSvg').each(function () {
            svg = this;
        });
        this.svg = svg;

        this.setPathD(this.props.tier, this.props.beatCount, this.props.startAngle, this.props.endAngle, this.props.withCorner, this.props.radius);
        this.setupEvents();
    }

    componentWillUpdate(nextProps) {
        if (nextProps.startAngle !== this.props.startAngle || nextProps.endAngle !== this.props.endAngle || nextProps.tier !== this.props.tier || nextProps.radius !== this.props.radius) {
            this.setPathD(nextProps.tier, nextProps.beatCount, nextProps.startAngle, nextProps.endAngle, nextProps.withCorner, nextProps.radius);
        }
    }

    setupEvents = () => {
        if (!this.props.mobileView) {
            const drag = d3.drag()
                .on('start', () => {
                    if (!this.svg || !this.g || !this.props.studioStore.advancedMode) {
                        return;
                    }
                    const angle = getAngleFromD3Event(this.svg, this.g, true);
                    const beat = getBeatFromAngle(angle, this.props.beatCount);
                    if (this.props.onDragStart) {
                        this.props.onDragStart(angle, beat);
                    }
                })
                .on('drag', () => {
                    if (!this.svg || !this.g || !this.props.studioStore.advancedMode) {
                        return;
                    }
                    const angle = getAngleFromD3Event(this.svg, this.g, true);
                    const beat = getBeatFromAngle(angle, this.props.beatCount);
                    if (this.props.onDrag) {
                        this.props.onDrag(angle, beat);
                    }
                })
                .on('end', () => {
                    if (!this.svg || !this.g || !this.props.studioStore.advancedMode) {
                        return;
                    }
                    const angle = getAngleFromD3Event(this.svg, this.g, true);
                    const beat = getBeatFromAngle(angle, this.props.beatCount);
                    if (this.props.onDragEnd) {
                        this.props.onDragEnd(angle, beat);
                    }
                });
            d3.select(this.g).call(drag);
        }

        d3.select(this.g)
            .on('click', () => {
                if (!this.svg || !this.g || !this.props.studioStore.advancedMode) {
                    return;
                }
                const angle = getAngleFromD3Event(this.svg, this.g, false);
                const beat = getBeatFromAngle(angle, this.props.beatCount);
                if (device.ipad()) {
                    if (this.pendingClickId) {
                        if (this.props.onDoubleClick) {
                            this.props.onDoubleClick(angle, beat);
                        }
                        clearTimeout(this.pendingClickId);
                        this.setPendingClickId(null);
                    } else {
                        const timeoutId = setTimeout(() => {
                            if (this.props.onClick) {
                                this.props.onClick(angle, beat);
                            }

                            this.setPendingClickId(null);
                        }, 300);
                        this.setPendingClickId(timeoutId);
                    }
                } else if (this.props.onClick) {
                    this.props.onClick(angle, beat);
                }
            })
            .on('dblclick', () => {
                if (!this.svg || !this.g || !this.props.studioStore.advancedMode) {
                    return;
                }
                const angle = getAngleFromD3Event(this.svg, this.g, false);
                const beat = getBeatFromAngle(angle, this.props.beatCount);
                if (this.props.onDoubleClick) {
                    this.props.onDoubleClick(angle, beat);
                }
            });
    };


    prepareBaseArc = (tier, withCorner = false, radius = 0) => {
        const extraWidth = this.props.mobileView && 75;
        const arc = d3.arc()
            .innerRadius(getInnerRadius(tier, extraWidth) + radius)
            .outerRadius(getOuterRadius(tier, extraWidth) - radius);
        if (withCorner) {
            arc.cornerRadius(20);
        }
        return arc;
    };


    @action setPathD = (tier, beatCount, startAngle, endAngle, withCorner, radius) => {
        const d3Arc = this.prepareBaseArc(tier, withCorner, radius);
        this.d = d3Arc
            .startAngle(startAngle)
            .endAngle(endAngle)();

    };

    @action setPendingClickId = (val) => {
        this.pendingClickId = val;
    };

    setRef = (g) => {
        this.g = g;
    };

    render() {
        const {fillColor, className, hoverClassName, isHovering, style} = this.props;
        return (
            <g ref={this.setRef}>
                <path
                    d={this.d} className={`${className} ${isHovering ? hoverClassName : ''}`}
                    onMouseOver={!device.ipad() ? this.props.onMouseOver : undefined} onMouseLeave={this.props.onMouseLeave}
                    style={Object.assign({}, {fill: fillColor}, style)}
                />
            </g>
        );
    }
}

StudioPlayerTrackArc.propTypes = {
    tier: PropTypes.number.isRequired,
    beatCount: PropTypes.number,
    startAngle: PropTypes.number,
    endAngle: PropTypes.number,
    fillColor: PropTypes.string,
    withCorner: PropTypes.bool,
    onClick: PropTypes.func,
    onDoubleClick: PropTypes.func,
    className: PropTypes.string,
    hoverClassName: PropTypes.string,
    style: PropTypes.object,
    radius: PropTypes.number,
    mobileView: PropTypes.bool
};

export default StudioPlayerTrackArc;
